import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BgTooltipComponent, BgTooltipService } from '@Omnissimo/betelgeuse';
import { Subject, takeUntil } from 'rxjs';
import { LanguageService, MODULE_PATHS } from './global/language.service';
import { BootstrapModalComponent } from './layout/modal/bootstrap-modal.component';

@Component({
    selector: 'app-root',
    imports: [CommonModule, RouterOutlet, BootstrapModalComponent, BgTooltipComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})

export class AppComponent implements OnDestroy {
    title = 'generic_angular_fe';
    private readonly onDestory$ = new Subject<void>();

    constructor(
        private readonly languageService: LanguageService,
        public readonly tooltipService: BgTooltipService
    ) {
        this.languageService.loadTranslations(MODULE_PATHS.CHANGE)
            .pipe(takeUntil(this.onDestory$))
            .subscribe();
    }

    ngOnDestroy(): void {
        this.onDestory$.next();
        this.onDestory$.complete();
    }
}
